export default function serviceDesignExpanders() {
    for (const link of document.querySelectorAll('[data-expand-link]')) {
        link.addEventListener('click', () => {
            const id = link.getAttribute('data-expand-link');
            const $target = $(`[data-expand-item="${id}"]`);
            const expandAttr = 'data-expanded';

            $target.slideToggle('500', () => {
                if (link.hasAttribute(expandAttr)) {
                    link.removeAttribute(expandAttr);
                } else {
                    link.setAttribute(expandAttr, '');
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/serviceDesignerExpanders.js